import { formValueSelector } from 'redux-form';

export const getConfirmValues = (state, formName) => {
  const selector = formValueSelector(formName);
  return {
    first_name: selector(state, 'first_name'),
    last_name: selector(state, 'last_name'),
    year: selector(state, 'year'),
    month: selector(state, 'month'),
    day: selector(state, 'day'),
  };
};

export const getSsnOptoutValue = (state, formName) =>
  formValueSelector(formName)(state, 'national_id_number_optout') || false;

export const getDobValues = (state, formName) => {
  const selector = formValueSelector(formName);
  return {
    year: selector(state, 'year'),
    month: selector(state, 'month'),
    day: selector(state, 'day'),
  };
};
